<template>
<div class="body">
  <h2>Let's Get Started!</h2>
  <h3>Tell us a bit about your event:</h3>
  <input type='text' placeholder='Event Name' v-model='eventName'/>
  <v-date-picker
    mode='range'
    is-double-paned
    :attributes='attrs'
    v-model='eventRange'>
  </v-date-picker>
  <input type='button' value='next' @click='save()'/>
</div>
</template>

<script>
export default {
  data() {
    return {
      eventName: "",
      eventRange: null,
      attrs: [
        {
          key: "today",
          dates: new Date(),
          highlight: {
            backgroundColor: "#ff8080"
          },
          contentStyle: {
            color: "#fafafa"
          },
          popover: null
        }
      ]
    };
  },
  methods: {
    save: function() {
      this.$store
        .dispatch("events/create", {
          name: this.eventName,
          start: this.eventRange.start,
          end: this.eventRange.end
        })
        .then(newEvent => {
          this.$router.push("/event/" + newEvent.id);
        });
    }
  }
};
</script>

<style scoped lang='scss'>
.body {
  margin-top: 48px;
  align-self: center;
  display: flex;
  align-items: center;
  flex-direction: column;
  border: 2px solid $gray-4;
  padding: 12px;
  border-radius: 8px;
  width: 800px;
  height: 600px;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/eventCreationPrompt.vue